import { render, staticRenderFns } from "./QueueLambda.vue?vue&type=template&id=b21bceb8"
import script from "./QueueLambda.vue?vue&type=script&lang=ts"
export * from "./QueueLambda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports